import { useMemo } from "react";
import _ from "lodash";

import theme from "theme";
import { googleMapsGetStaticMapUrl } from "utils/maps";

import Box from "components/Box";
import NoPrint from "components/NoPrint";
import Stack from "components/Stack";

import LocationEditButton from "entities/Deal/components/OverviewLocation/LocationEditButton";
import LocationTable from "entities/Deal/components/OverviewLocation/LocationTable";
import { IDeal } from "entities/Deal/sdk";
import MemoSectionContextButton from "entities/Memo/components/Sections/ContextButton";
import NASection from "entities/Memo/components/Sections/NASection";
import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";

const SectionLocation = ({
  deal,
  sectionName = "",
  section,
  externalToken,
  onUpdate,
}: {
  deal: IDeal;
  sectionName?: string;
  section?: IMemoSection;
  externalToken?: string;
  onUpdate?: () => void;
}) => {
  const mapUrl = useMemo(() => {
    if (_.isEmpty(deal.address)) {
      return "#";
    }

    const markers = [
      {
        center: {
          lng: Number(deal.address.longitude),
          lat: Number(deal.address.latitude),
        },
        contentdata: {
          project_name: deal.name,
          address: `${deal.address.street_address}, ${deal.address.city}, ${deal.address.zipcode}`,
          thumbnail: deal.thumbnail,
        },
      },
    ];

    return googleMapsGetStaticMapUrl({ markers });
  }, [deal]);

  const isNASection = useMemo(() => section?.is_na, [section]);

  return (
    <Box data-testid="location-section">
      <SectionHeader
        label={section?.title || sectionName}
        alignActionButton={section ? "right" : "left"}
        actionButton={
          _.isUndefined(externalToken) && (
            <NoPrint>
              <Stack direction="row" spacing={1} alignItems="center">
                {!isNASection && <LocationEditButton />}
                {section && (
                  <MemoSectionContextButton
                    dealId={deal.id}
                    section={section}
                    onUpdate={onUpdate}
                  />
                )}
              </Stack>
            </NoPrint>
          )
        }
      />
      <SectionContent breakInside="avoid">
        {isNASection ? (
          <NASection />
        ) : (
          <>
            {deal.address && <LocationTable address={deal.address} />}
            <img
              key={mapUrl}
              src={mapUrl}
              style={{
                width: "100%",
                height: "400px",
                objectFit: "cover",
                marginTop: theme.spacing(1),
              }}
              alt="Map"
              id="map-image"
              data-testid="google-map-with-locations"
            />
          </>
        )}
      </SectionContent>
    </Box>
  );
};

export default SectionLocation;
